import React, { useState, useEffect } from "react";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import Announcement from "./components/Announcement";
import AllSpaceStatus from "./components/AllSpaceStatus";
import LoadingSpinner from "./components/LoadingSpinner";
// import CryptoJS from 'crypto-js';
import moment from "moment";
import { FormattedMessage, useIntl } from "react-intl";
import { AlertSwal } from "./components/CustomSwal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function App(props) {
  const [account, setAccount] = useState("");
  const [password, setPassword] = useState("");
  const [pwdShow, setPwdShow] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [show, setShow] = useState(false);
  const [announcementShow, setAnnouncementShow] = useState(true);
  const [spaceStatus, setSpaceStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [spaceData, setSpaceData] = useState(null);
  const [captchaCountdown, setCaptchaCountdown] = useState(
    props.config.CAPTCHA_COUNTDOWN
  );
  const [captchaKey, setCaptchaKey] = useState(Math.random());
  const config = props.config;
  const intl = useIntl();

  const ChkCaptcha = () => {
    if (config.CAPTCHA_URL === null) return UserAuth();
    let valid = true;
    let invalidMsg = "";
    if (!document.getElementById("captcha").value.trim().length) {
      valid = false;
      invalidMsg = intl.formatMessage({ id: "login.captcha_not_null" });
    }
    if (valid) {
      setLoading(true);
      axios
        .get(config.API_URL + `/ChkCaptcha.aspx`, {
          params: {
            captcha: document.getElementById("captcha").value,
          },
        })
        .then((res) => {
          const data = res.data;
          if (data === 1) {
            UserAuth();
          } else {
            setLoading(false);
            setCaptchaKey(Math.random());
            AlertSwal.fire({
              title: intl.formatMessage({ id: "global.alert_title" }),
              text: intl.formatMessage({ id: "login.captcha_failed" }),
              confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          AlertSwal.fire({
            title: intl.formatMessage({ id: "global.alert_title" }),
            text: error,
            confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
          });
        });
    } else {
      setLoading(false);
      AlertSwal.fire({
        title: intl.formatMessage({ id: "global.alert_title" }),
        text: invalidMsg,
        confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
      });
    }
  };

  const UserAuth = () => {
    let valid = true;
    let invalidMsg = "";
    if (!account.trim().length || !password.trim().length) {
      valid = false;
      invalidMsg = intl.formatMessage({ id: "login.not_null" });
    }
    let lang = props.locale;
    if (lang === "zh") {
      lang = "zh-tw";
    }
    if (valid) {
      setLoading(true);
      let sid = sessionStorage.getItem("sid");
      axios
        .get(config.API_URL + `/UserAuth.aspx`, {
          params: {
            sid: sid,
            account: account,
            password: password,
            lang: lang,
            restype: "json",
          },
        })
        .then((res) => {
          const data = res.data[0];
          if (data.rescode === "1") {
            localStorage.setItem("remembered", isChecked);
            if (isChecked) {
              localStorage.setItem("account", account.toUpperCase());
              // localStorage.setItem('password', crypt(password));
              let cryptedPwd = Buffer.from(password).toString("base64");
              localStorage.setItem("password", cryptedPwd);
            } else {
              localStorage.removeItem("account");
              localStorage.removeItem("password");
            }
            sessionStorage.setItem("userid", account.toUpperCase());
            sessionStorage.setItem(
              "logintime",
              moment().format("YYYY/MM/DD HH:mm:ss")
            );
            sessionStorage.setItem("authid", data.resdata[0].authid);
            sessionStorage.setItem("isblacklist", data.resdata[0].isblacklist);
            sessionStorage.setItem("cardnoexist", data.resdata[0].cardnoexist);
            sessionStorage.setItem("userstatus", data.resdata[0].status);
            props.history.push("redirect_to/info");
          } else {
            setCaptchaKey(Math.random());
            setLoading(false);
            AlertSwal.fire({
              title: intl.formatMessage({ id: "global.alert_title" }),
              text: data.resmsg,
              confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      setLoading(false);
      AlertSwal.fire({
        title: intl.formatMessage({ id: "global.alert_title" }),
        text: invalidMsg,
        confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
      });
    }
  };

  const DeviceAuth = () => {
    if (!config.OPENID_URL) {
      setLoading(true);
      axios
        .get(config.API_URL + `/DeviceAuth.aspx`, {
          params: {
            account: config.DEVICE_AUTH_ACC,
            password: config.DEVICE_AUTH_PASS,
            restype: "json",
          },
        })
        .then((res) => {
          const data = res.data[0];
          if (data.rescode === "1") {
            sessionStorage.setItem("sid", data.resdata[0].sid);
            checkRememberMe();
          } else {
            AlertSwal.fire({
              title: intl.formatMessage({ id: "global.alert_title" }),
              text: data.resmsg,
              confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
            });
          }
        })
        .catch((error) => {
          AlertSwal.fire({
            title: intl.formatMessage({ id: "global.alert_title" }),
            text: error,
            confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const GetSpaceStatus = (st) => {
    axios
      .get(config.API_URL + `/GetAllBookStatus_View.aspx`, {
        params: {
          spacetype: st,
          sdate: moment().format("YYYYMMDD"),
          sid: sessionStorage.getItem("sid"),
          restype: "json",
        },
      })
      .then((res) => {
        const data = res.data;
        if (data.rescode === 1 || data.rescode === "1") {
          setSpaceStatus(res.data);
        } else {
          AlertSwal.fire({
            title: intl.formatMessage({ id: "global.alert_title" }),
            text: "Failed:" + data.resmsg,
            confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
          });
        }
      })
      .catch((error) => {
        AlertSwal.fire({
          title: intl.formatMessage({ id: "global.alert_title" }),
          text: error,
          confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
        });
      });
  };

  const GetDevUseStatus = () => {
    if (config.SHOW_NEWS_AND_SPACE.indexOf("SPACE") !== -1) {
      setSpaceData(null);
      axios
        .get(config.API_URL + `/GetDevUseStatus.aspx`)
        .then((res) => {
          const data = res.data;
          if (data.rescode === 1 || data.rescode === "1") {
            setSpaceData(data.rows);
          } else {
            AlertSwal.fire({
              title: intl.formatMessage({ id: "global.alert_title" }),
              text: "Failed:" + data.resmsg,
              confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
            });
          }
        })
        .catch((error) => {
          AlertSwal.fire({
            title: intl.formatMessage({ id: "global.alert_title" }),
            text: error,
            confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
          });
        });
    }
  };

  const handleLang = (lang) => {
    sessionStorage.setItem("lang", lang);
    props.setLocale(lang);
  };

  const checkRememberMe = () => {
    const isRemembered =
      localStorage.getItem("remembered") === "true" ? true : false;
    setIsChecked(isRemembered);
    if (isRemembered) {
      const acc = localStorage.getItem("account");
      // const pwd = crypt(localStorage.getItem('password'));
      const pwd = Buffer.from(
        localStorage.getItem("password"),
        "base64"
      ).toString();
      setAccount(acc);
      setPassword(pwd);
    }
  };

  // useEffect(() => {
  //   let key = CryptoJS.enc.Utf8.parse("(055)2813338microprogram");
  //   let iv = CryptoJS.enc.Hex.parse("00000000");
  //   let encrypted = CryptoJS.enc.Hex.parse('AE7874BF5C78A41DED14BE40BE8BF89CE470018E54B8407C1255E0F45CFDDFD381A5218CF6F24A11').toString(CryptoJS.enc.Base64);
  //   let decrypted = CryptoJS.TripleDES.decrypt(encrypted, key, { iv: iv });
  //   console.log(decrypted.toString(CryptoJS.enc.Utf8));

  //   let d = '879a65&0&1&W082127&20210805175027'
  //   let test = CryptoJS.TripleDES.encrypt(d, key, { iv: iv });
  //   console.log(Buffer.from(test.toString(), 'base64').toString('hex'));
  // }, []);

  useEffect(DeviceAuth, []);
  useEffect(GetDevUseStatus, []);

  useEffect(() => {
    if (config.CAPTCHA_URL !== null && !config.OPENID_URL) {
      document.getElementById("captcha").value = "";
      setCaptchaCountdown(config.CAPTCHA_COUNTDOWN);
      let captchaCDInterval = setInterval(() => {
        setCaptchaCountdown((prev) => {
          if (prev !== 0) return prev - 1;
        });
      }, 1000);
      return () => {
        clearInterval(captchaCDInterval);
      };
    }
  }, [
    captchaKey,
    config.CAPTCHA_COUNTDOWN,
    config.CAPTCHA_URL,
    config.OPENID_URL,
  ]);

  useEffect(() => {
    if (captchaCountdown === 0) {
      setCaptchaKey(Math.random());
    }
  }, [captchaCountdown, config.CAPTCHA_COUNTDOWN]);

  const footerLeft = props.messages.login.footer.left;
  const footerRight = props.messages.login.footer.right;

  let isAnnouncementShow = null;
  if (config.SPECIAL_ANNOUNCEMENT_PERIOD) {
    if (config.SPECIAL_ANNOUNCEMENT_PERIOD === true) {
      isAnnouncementShow = (
        <Announcement
          show={announcementShow}
          setShow={setAnnouncementShow}
          announcement_messages={props.messages.special.announcement}
        />
      );
    } else {
      const stime = moment(
        config.SPECIAL_ANNOUNCEMENT_PERIOD.split(" ~ ")[0],
        "YYYY/MM/DD HH:mm:ss"
      );
      const etime = moment(
        config.SPECIAL_ANNOUNCEMENT_PERIOD.split(" ~ ")[1],
        "YYYY/MM/DD HH:mm:ss"
      );
      if (moment().isBetween(stime, etime)) {
        isAnnouncementShow = (
          <Announcement
            show={announcementShow}
            setShow={setAnnouncementShow}
            announcement_messages={props.messages.special.announcement}
          />
        );
      }
    }
  }

  let newsAndSpace = [];
  if (config.SHOW_NEWS_AND_SPACE.length > 0) {
    for (let i = 0; i < config.SHOW_NEWS_AND_SPACE.length && i < 2; i++) {
      if (config.SHOW_NEWS_AND_SPACE[i] === "NEWS") {
        newsAndSpace.push(
          <div className="mt-5" key={i}>
            <hr />
            <h5 className="text-center pb-3 font-weight-bold text-dark">
              <FormattedMessage id="login.bulletin" />
            </h5>
            <div className="bulletin_container">
              <iframe
                title="bulletin"
                src={`rss_content.html?lang=${props.locale}`}
                frameBorder="0"
              ></iframe>
            </div>
          </div>
        );
      } else if (config.SHOW_NEWS_AND_SPACE[i] === "SPACE") {
        newsAndSpace.push(
          <div className="mt-5" key={i}>
            <hr />
            <h5 className="text-center pb-0 font-weight-bold text-dark">
              <FormattedMessage id="login.space_status" />
            </h5>
            <div className="pb-2 text-center">
              {config.ST_ORDER.map((st) => (
                <b key={st}>
                  [
                  <button
                    className="px-1 a_link_button"
                    onClick={() => {
                      GetSpaceStatus(st);
                    }}
                  >
                    <FormattedMessage id={`global.spacetype.${st}`} />
                  </button>
                  ]
                </b>
              ))}
            </div>
            <div className="space_container">
              {spaceData ? (
                <Table size="sm" bordered striped>
                  <thead>
                    <tr>
                      <th>
                        <FormattedMessage id="global._spacetype" />
                      </th>
                      <th>
                        <FormattedMessage id="global.zonename" />
                      </th>
                      <th style={{ maxWidth: "90px" }}>
                        <FormattedMessage id="login.space_remain" />
                        <span className="d-block">
                          <button
                            className="a_link_button"
                            onClick={() => {
                              GetDevUseStatus();
                            }}
                          >
                            <FormattedMessage id="login.space_update" />
                          </button>
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {spaceData.map((row, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <FormattedMessage
                              defaultMessage={row.spacetypename}
                              id={`global.spacetype.${row.spacetype}`}
                            />
                          </td>
                          <td>
                            <FormattedMessage
                              defaultMessage={row.zonename}
                              id={`global.zoneid.${row.zoneid}`}
                            />
                          </td>
                          <td>{row.count}</td>
                        </tr>
                      );
                    })}
                    {spaceData.length === 0 ? (
                      <tr>
                        <td colSpan={3}>
                          <FormattedMessage id="global.no_data" />
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </Table>
              ) : (
                <LoadingSpinner
                  style={{ position: "absolute", zIndex: "1000" }}
                  loading={true}
                />
              )}
            </div>
          </div>
        );
      }
    }
  }

  return (
    <>
      <div className="position-relative top_img">
        <div className="site_title">
          <div className="container pt-3 pb-3">
            <div className="d-md-flex justify-content-between text-center">
              <div className="logo_wrap">
                <img src="./img/logo.png" alt="" />
              </div>
              <div className="d-flex align-items-center justify-content-around mt-3 mt-md-0">
                <button
                  className={
                    "font-weight-bold pl-2 pr-2 a_button " +
                    (props.locale === "zh" ? "" : "a_link_button")
                  }
                  onClick={() => {
                    handleLang("zh");
                  }}
                >
                  中文
                </button>
                <button
                  className={
                    "font-weight-bold pl-2 pr-2 a_button " +
                    (props.locale === "en" ? "" : "a_link_button")
                  }
                  onClick={() => {
                    handleLang("en");
                  }}
                >
                  English
                </button>
                {props.messages.login.user_guide.href_zh !== "" && (
                  <a
                    className="pl-2 pr-2 a_button a_link_button"
                    href={props.messages.login.user_guide.href_zh}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {props.messages.login.user_guide.content_zh}
                  </a>
                )}
                {props.messages.login.user_guide.href_en !== "" && (
                  <a
                    className="pl-2 pr-2 a_button a_link_button"
                    href={props.messages.login.user_guide.href_en}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {props.messages.login.user_guide.content_en}
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="login_content_container">
        <div className="login_content">
          <div className="container">
            <h5 className="text-center pb-3 font-weight-bold text-dark">
              <FormattedMessage id="global.school_lib" />
            </h5>
            {config.OPENID_URL ? (
              <div className="ssoLogin">
                <b>
                  <FormattedMessage id="login.sso_msg1" />
                </b>
                <b>
                  <FormattedMessage id="login.sso_msg2" />
                </b>
                <Button
                  variant="primary"
                  className="w-100 pt-2 pb-2 bg_brand"
                  onClick={() => {
                    setLoading(true);
                    window.location.href = props.config.OPENID_URL;
                  }}
                >
                  <FormattedMessage id="login.sso_login" />
                </Button>
              </div>
            ) : (
              <>
                <div className="form-group userid position-relative">
                  <svg
                    width="1em"
                    height="1em"
                    viewBox="0 0 16 16"
                    className="bi bi-person-fill position-absolute"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                    />
                  </svg>
                  <FormattedMessage id="login.account">
                    {(placeholder) => (
                      <input
                        id="login_account"
                        type="text"
                        className="form-control"
                        placeholder={placeholder}
                        name="account"
                        value={account}
                        onChange={(e) => {
                          setAccount(e.target.value);
                        }}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            ChkCaptcha();
                          }
                        }}
                      />
                    )}
                  </FormattedMessage>
                </div>
                <div className="form-group password position-relative">
                  <svg
                    width="1em"
                    height="1em"
                    viewBox="0 0 16 16"
                    className="bi bi-lock-fill position-absolute"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M2.5 9a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V9z" />
                    <path
                      fillRule="evenodd"
                      d="M4.5 4a3.5 3.5 0 1 1 7 0v3h-1V4a2.5 2.5 0 0 0-5 0v3h-1V4z"
                    />
                  </svg>
                  <FormattedMessage id="login.password">
                    {(placeholder) => (
                      <input
                        id="login_password"
                        type={pwdShow ? "text" : "password"}
                        className="form-control"
                        placeholder={placeholder}
                        name="password"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                        }}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            UserAuth();
                          }
                        }}
                      />
                    )}
                  </FormattedMessage>
                  <button
                    className="password_show"
                    onClick={() => {
                      setPwdShow(!pwdShow);
                    }}
                  >
                    {pwdShow ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1.5em"
                        height="1.5em"
                        viewBox="0 0 50 50"
                      >
                        <path d="M 25.144531 8 C 19.103964 8 13.561453 10.431954 9.2792969 14.439453 A 1.0001 1.0001 0 1 0 10.646484 15.898438 C 14.596328 12.201935 19.639099 10 25.144531 10 C 30.622398 10 35.641117 12.180148 39.582031 15.84375 A 1.0001 1.0001 0 1 0 40.943359 14.378906 C 36.670274 10.406508 31.154664 8 25.144531 8 z M 45.490234 20.9375 A 1.0001 1.0001 0 0 0 44.556641 21.625 C 40.545678 29.071912 33.337413 34 25.117188 34 C 16.915226 34 9.721572 29.091708 5.7050781 21.671875 A 1.0001 1.0001 0 0 0 3.7578125 22 L 3.7578125 22.048828 A 1.0001 1.0001 0 0 0 3.875 22.521484 C 5.2332071 25.057502 6.9512191 27.330506 8.9472656 29.257812 L 3.2695312 35.316406 A 1.0004426 1.0004426 0 0 0 4.7304688 36.683594 L 10.441406 30.587891 C 12.090811 31.948408 13.894282 33.09259 15.822266 33.96875 L 12.101562 41.560547 A 1.0001549 1.0001549 0 1 0 13.898438 42.439453 L 17.683594 34.712891 C 19.691189 35.420885 21.807993 35.849597 24.001953 35.958984 A 1.0001 1.0001 0 0 0 24 36 L 24 44 A 1.0001 1.0001 0 1 0 26 44 L 26 36 A 1.0001 1.0001 0 0 0 25.998047 35.966797 C 28.264048 35.87761 30.449568 35.441539 32.519531 34.716797 L 36.09375 42.419922 A 1.0001 1.0001 0 1 0 37.90625 41.580078 L 34.376953 33.96875 C 36.184396 33.152619 37.884395 32.108088 39.449219 30.863281 L 45.292969 36.707031 A 1.0001 1.0001 0 0 0 46.109375 37.009766 A 1.0001 1.0001 0 0 0 46.207031 36.996094 A 1.0001 1.0001 0 0 0 46.707031 35.292969 L 40.964844 29.550781 C 43.109605 27.548898 44.953216 25.160853 46.386719 22.470703 A 1.0001 1.0001 0 0 0 46.505859 22 L 46.505859 21.951172 A 1.0001 1.0001 0 0 0 45.490234 20.9375 z"></path>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1.5em"
                        height="1.5em"
                        viewBox="0 0 50 50"
                      >
                        <path d="M 25 12 C 11.667969 12 1.25 24.34375 1.25 24.34375 C 0.921875 24.71875 0.921875 25.28125 1.25 25.65625 C 1.25 25.65625 11.667969 38 25 38 C 38.332031 38 48.75 25.65625 48.75 25.65625 C 49.078125 25.28125 49.078125 24.71875 48.75 24.34375 C 48.75 24.34375 38.332031 12 25 12 Z M 25 14 C 27.628906 14 30.140625 14.542969 32.46875 15.375 C 34.03125 17.140625 35 19.449219 35 22 C 35 27.535156 30.535156 32 25 32 C 19.464844 32 15 27.535156 15 22 C 15 19.449219 15.9375 17.140625 17.5 15.375 C 19.835938 14.539063 22.363281 14 25 14 Z M 14.1875 16.84375 C 13.4375 18.40625 13 20.15625 13 22 C 13 28.617188 18.382813 34 25 34 C 31.617188 34 37 28.617188 37 22 C 37 20.164063 36.582031 18.40625 35.84375 16.84375 C 41.492188 19.714844 45.554688 23.878906 46.59375 25 C 44.96875 26.757813 35.972656 36 25 36 C 14.027344 36 5.03125 26.757813 3.40625 25 C 4.445313 23.875 8.527344 19.714844 14.1875 16.84375 Z M 25 17 C 22.238281 17 20 19.238281 20 22 C 20 24.761719 22.238281 27 25 27 C 27.761719 27 30 24.761719 30 22 C 30 19.238281 27.761719 17 25 17 Z"></path>
                      </svg>
                    )}
                  </button>
                </div>
                {config.CAPTCHA_URL ? (
                  <div className="form-group position-relative">
                    <FormattedMessage id="login.captcha">
                      {(placeholder) => (
                        <input
                          id="captcha"
                          type="text"
                          className="form-control"
                          placeholder={placeholder}
                          name="captcha"
                          maxLength={4}
                          onKeyPress={(e) => {
                            if (e.key === "Enter") {
                              ChkCaptcha();
                            }
                          }}
                        />
                      )}
                    </FormattedMessage>
                    <img
                      alt="Captcha"
                      className="captcha"
                      src={config.CAPTCHA_URL + "?random=" + captchaKey}
                    ></img>
                    <FontAwesomeIcon
                      icon={["fas", "sync-alt"]}
                      className="captcha_refresh"
                      title={intl.formatMessage({
                        id: "login.captcha_refresh",
                      })}
                      onClick={() => {
                        document.getElementById("captcha").value = "";
                        setCaptchaKey(Math.random());
                      }}
                    />
                    <span
                      className="captcha_refresh_cd"
                      onClick={() => {
                        setCaptchaKey(Math.random());
                      }}
                    >
                      {captchaCountdown}
                    </span>
                  </div>
                ) : null}
                <div className="d-flex justify-content-between pb-3">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="login_info_lock"
                      checked={isChecked}
                      onChange={(e) => {
                        setIsChecked(!isChecked);
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="login_info_lock"
                    >
                      <FormattedMessage id="login.remember_me" />
                    </label>
                  </div>
                  <button
                    className="d-flex justify-content-center align-items-center login_tutorial"
                    onClick={() => setShow(true)}
                  >
                    <i className="icon_login"></i>
                    <span>
                      <FormattedMessage id="login.tutorial" />
                    </span>
                  </button>
                </div>
                <Button
                  variant="primary"
                  onClick={ChkCaptcha}
                  className="w-100 pt-2 pb-2 bg_brand"
                >
                  <FormattedMessage id="login.login" />
                </Button>
              </>
            )}
          </div>
          {newsAndSpace.map((row) => row)}
        </div>
      </div>
      <div className="footer_container">
        <ul>
          {Object.keys(footerLeft).map((item, i) => {
            return (
              <li key={i}>
                <a
                  href={footerLeft[item].href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={["fas", footerLeft[item].icon]} />
                  {footerLeft[item].content}
                </a>
              </li>
            );
          })}
        </ul>
        <ul>
          {Object.keys(footerRight).map((item, i) => {
            return (
              <li key={i}>
                <a
                  href={footerRight[item].href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={["fas", footerRight[item].icon]} />
                  {footerRight[item].content}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
      <Modal
        size="xl"
        show={show}
        onHide={() => {
          setShow(false);
        }}
        centered
      >
        <Modal.Header className="bg_brand" closeButton>
          <Modal.Title>
            <span>
              <FormattedMessage id="login.tutorial" />
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <b className="d-block">
            <FormattedMessage id="login.tutorial_account" />
          </b>
          <b className="d-block">
            <FormattedMessage id="login.tutorial_password" />
          </b>
          <hr />
          <Button
            href={props.messages.login.tutorial_check_account.href}
            target="_blank"
            variant="link"
            className="pl-0"
          >
            <FormattedMessage id="login.tutorial_check_account.content" />
          </Button>
          <Button
            href={props.messages.login.tutorial_forget_password.href}
            target="_blank"
            variant="link"
          >
            <FormattedMessage id="login.tutorial_forget_password.content" />
          </Button>
          <span className="d-block">
            <FormattedMessage id="login.tutorial_others" />
          </span>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-end">
          <Button
            className="bg_brand"
            variant="primary"
            onClick={() => setShow(false)}
          >
            <FormattedMessage id="global.confirm" />
          </Button>
        </Modal.Footer>
      </Modal>
      <AllSpaceStatus
        config={config}
        spaceStatus={spaceStatus}
        setSpaceStatus={setSpaceStatus}
      />
      <LoadingSpinner loading={loading} />
      {isAnnouncementShow}
    </>
  );
}

export { App };
